export default "__VITE_ASSET__DqtO15yh__"